import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import SportList from './SportList';
import Query from './Queries';
import AddQuery from './AddQuery'
import LaunchPipeline from './LaunchPipeline'
import { queryActions, sportActions, pipelineActions } from './_actions';
import logo from './logo.svg';
import Paper from 'material-ui/Paper';
import {List} from 'material-ui/List';

class Dashboard extends Component {
	constructor (props) {
		super(props)
		this.onSportSelect = this.onSportSelect.bind(this);
		this.onAddQuery = this.onAddQuery.bind(this);
		this.onQueryToggle = this.onQueryToggle.bind(this);
		this.onDeleteQuery = this.onDeleteQuery.bind(this);
		this.onLaunchPipeline = this.onLaunchPipeline.bind(this);
	}

	onSportSelect (sport) {
		if (sport){
			const { dispatch, jwtToken } = this.props;
			dispatch(sportActions.selectSport(sport));
			dispatch(queryActions.getActive(jwtToken, sport));
			dispatch(queryActions.getInactive(jwtToken, sport));
		}
	}

	onDeleteQuery (query) {
		const { dispatch, jwtToken, selectedSport } = this.props;
		dispatch(queryActions.deleteQuery(jwtToken, selectedSport, query));
		dispatch(queryActions.getActive(jwtToken, selectedSport));
		dispatch(queryActions.getInactive(jwtToken, selectedSport));
	}

  onAddQuery (query) {
		const { dispatch, jwtToken, selectedSport } = this.props;
		console.log("OnAddQuery: ", selectedSport, query); 
		dispatch(queryActions.addQuery(jwtToken, selectedSport, query))
		dispatch(queryActions.getActive(jwtToken, selectedSport));
		dispatch(queryActions.getInactive(jwtToken, selectedSport));
	}	

	onLaunchPipeline () {
		const { dispatch, jwtToken, selectedSport } = this.props;
		console.log("Launching Pipeline for Sport: ", selectedSport);
		dispatch(pipelineActions.launchPipeline(jwtToken, selectedSport))
	}

	onQueryToggle (clickEvent, isChecked, query) {
		const { dispatch, jwtToken, selectedSport } = this.props;
		
		if (isChecked){
			dispatch(queryActions.activateQuery(jwtToken, selectedSport, query));
		}
		else{
			dispatch(queryActions.deactivateQuery(jwtToken, selectedSport, query));
		}
		dispatch(queryActions.getActive(jwtToken, selectedSport));
		dispatch(queryActions.getInactive(jwtToken, selectedSport));
	}

  //componentDidMount() {
  //  const { dispatch, selectedSport, jwtToken } = this.props
  //  dispatch(queryActions.getActive(jwtToken, selectedSport));
	//	dispatch(queryActions.getInactive(jwtToken, selectedSport));
  //}

	componentDidUpdate(prevProps) {
		if (this.props.selectedSport !== prevProps.selectedSport) {
    	const { dispatch, selectedSport, jwtToken } = this.props
    	dispatch(queryActions.getActive(jwtToken, selectedSport));
			dispatch(queryActions.getInactive(jwtToken, selectedSport));
    }
  }

  render() {
		const { availableSports, queries, selectedSport  } = this.props;
		const queryList = queries.map((query) => 
					<Query key={query.query} query={query.query} active={query.active == "1"} toggleQuery={this.onQueryToggle} deleteQuery={this.onDeleteQuery}/>
		);
		let RenderSports = null;

		if (availableSports.length === 0) {
			RenderSports = <LoadingSports />;
		}
		else {
			RenderSports = <Sports sports={availableSports} onSportSelect={this.onSportSelect}/>;
		}

		return (
			<SplitPane
				left={ RenderSports}
				right=
				{ <div>
						{ selectedSport &&
							<div>
							<LaunchPipeline 
								onLaunchClick={this.onLaunchPipeline}
							/>
							<AddQuery
								onAddQueryClick={this.onAddQuery}
								sport={selectedSport}
							/>
							</div>
						}
						{ queries && queries.length !== 0 &&
							<Paper zDepth={2}>
								<List>{queryList}</List>
							</Paper>
						}
					</div>
				}
			/>
		)
	}
}

Dashboard.propTypes = {
  jwtToken: PropTypes.string.isRequired
}

function Sports(props){
		return <SportList items={props.sports} onSportSelect={props.onSportSelect} />
}

function LoadingSports(props) {
		return <div>
							<img src={logo} className="App-logo" alt="logo" />
							<h2>Loading Sports</h2>
						</div>
}

function SplitPane(props) {
  return (
    <div className="SplitPane">
      <div className="SplitPane-left">
        {props.left}
      </div>
      <div className="SplitPane-right">
        {props.right}
      </div>
    </div>
  );
}

function mapStateToProps(state){
			const { sports, queries } = state;
			let availableSports = [];
			let selectedSport = null;
			if (sports.items){
				availableSports = sports.items;
			}

			if (sports.selectedSport){
				selectedSport = sports.selectedSport;
			}
			
			let inactiveQueries = [];
			let activeQueries = [];			
			let allQueries = [];
	
			if (queries.inactiveQueries){
				inactiveQueries = queries.inactiveQueries;
			}
			if (queries.activeQueries){
				activeQueries = queries.activeQueries;
			}
			allQueries = allQueries.concat(activeQueries);
			allQueries = allQueries.concat(inactiveQueries);
			return {
				...state,
				selectedSport,
				availableSports,
				queries: allQueries,
			}
}

const connectedDashboard = connect(mapStateToProps)(Dashboard);
export default connectedDashboard;



// WEBPACK FOOTER //
// ./src/Dashboard.jsx